import React, { useState, useEffect } from "react";
import Axios from "axios";
import Navbar from "../../components/Navbar";
import Background from "../../components/Background";
import Container from "../../components/Container";
import Header from "../../components/Header";
import style from "./Containers.module.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import VintePes from "./20.png";
import QuarentaPes from "./40.png";
import modalStyle from "./Modal.module.css"; // Importando o estilo modular


const Containers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [tipofluxo, setTipoFluxo] = useState("ENTRADA");
  const [hasDamage, setHasDamage] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [numeroContainer, setNumeroContainer] = useState("");
  const [cpfMotorista, setCpfMotorista] = useState("");
  const [nomeMotorista, setNomeMotorista] = useState("");
  const [transportadoras, setTransportadoras] = useState([]); // Estado para lista de transportadoras
  const [selectedTransportadora, setSelectedTransportadora] = useState(null); // Estado para a transportadora selecionada
  const [observacao, setObservacao] = useState("");
  const [codMotorista, setCodMotorista] = useState(null); // Armazena o COD_MOTORISTA
  const [showModal, setShowModal] = useState(false); // Controle do modal
  const [nomeMotoristaModal, setNomeMotoristaModal] = useState(""); // Nome inserido no modal

  const LOGO_BASE64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKcAAAA8CAYAAAADt6psAAAKN2lDQ1BzUkdCIElFQzYxOTY2LTIuMQAAeJydlndUU9kWh8+9N71QkhCKlNBraFICSA29SJEuKjEJEErAkAAiNkRUcERRkaYIMijggKNDkbEiioUBUbHrBBlE1HFwFBuWSWStGd+8ee/Nm98f935rn73P3Wfvfda6AJD8gwXCTFgJgAyhWBTh58WIjYtnYAcBDPAAA2wA4HCzs0IW+EYCmQJ82IxsmRP4F726DiD5+yrTP4zBAP+flLlZIjEAUJiM5/L42VwZF8k4PVecJbdPyZi2NE3OMErOIlmCMlaTc/IsW3z2mWUPOfMyhDwZy3PO4mXw5Nwn4405Er6MkWAZF+cI+LkyviZjg3RJhkDGb+SxGXxONgAoktwu5nNTZGwtY5IoMoIt43kA4EjJX/DSL1jMzxPLD8XOzFouEiSniBkmXFOGjZMTi+HPz03ni8XMMA43jSPiMdiZGVkc4XIAZs/8WRR5bRmyIjvYODk4MG0tbb4o1H9d/JuS93aWXoR/7hlEH/jD9ld+mQ0AsKZltdn6h21pFQBd6wFQu/2HzWAvAIqyvnUOfXEeunxeUsTiLGcrq9zcXEsBn2spL+jv+p8Of0NffM9Svt3v5WF485M4knQxQ143bmZ6pkTEyM7icPkM5p+H+B8H/nUeFhH8JL6IL5RFRMumTCBMlrVbyBOIBZlChkD4n5r4D8P+pNm5lona+BHQllgCpSEaQH4eACgqESAJe2Qr0O99C8ZHA/nNi9GZmJ37z4L+fVe4TP7IFiR/jmNHRDK4ElHO7Jr8WgI0IABFQAPqQBvoAxPABLbAEbgAD+ADAkEoiARxYDHgghSQAUQgFxSAtaAYlIKtYCeoBnWgETSDNnAYdIFj4DQ4By6By2AE3AFSMA6egCnwCsxAEISFyBAVUod0IEPIHLKFWJAb5AMFQxFQHJQIJUNCSAIVQOugUqgcqobqoWboW+godBq6AA1Dt6BRaBL6FXoHIzAJpsFasBFsBbNgTzgIjoQXwcnwMjgfLoK3wJVwA3wQ7oRPw5fgEVgKP4GnEYAQETqiizARFsJGQpF4JAkRIauQEqQCaUDakB6kH7mKSJGnyFsUBkVFMVBMlAvKHxWF4qKWoVahNqOqUQdQnag+1FXUKGoK9RFNRmuizdHO6AB0LDoZnYsuRlegm9Ad6LPoEfQ4+hUGg6FjjDGOGH9MHCYVswKzGbMb0445hRnGjGGmsVisOtYc64oNxXKwYmwxtgp7EHsSewU7jn2DI+J0cLY4X1w8TogrxFXgWnAncFdwE7gZvBLeEO+MD8Xz8MvxZfhGfA9+CD+OnyEoE4wJroRIQiphLaGS0EY4S7hLeEEkEvWITsRwooC4hlhJPEQ8TxwlviVRSGYkNimBJCFtIe0nnSLdIr0gk8lGZA9yPFlM3kJuJp8h3ye/UaAqWCoEKPAUVivUKHQqXFF4pohXNFT0VFysmK9YoXhEcUjxqRJeyUiJrcRRWqVUo3RU6YbStDJV2UY5VDlDebNyi/IF5UcULMWI4kPhUYoo+yhnKGNUhKpPZVO51HXURupZ6jgNQzOmBdBSaaW0b2iDtCkVioqdSrRKnkqNynEVKR2hG9ED6On0Mvph+nX6O1UtVU9Vvuom1TbVK6qv1eaoeajx1UrU2tVG1N6pM9R91NPUt6l3qd/TQGmYaYRr5Grs0Tir8XQObY7LHO6ckjmH59zWhDXNNCM0V2ju0xzQnNbS1vLTytKq0jqj9VSbru2hnaq9Q/uE9qQOVcdNR6CzQ+ekzmOGCsOTkc6oZPQxpnQ1df11Jbr1uoO6M3rGelF6hXrtevf0Cfos/ST9Hfq9+lMGOgYhBgUGrQa3DfGGLMMUw12G/YavjYyNYow2GHUZPTJWMw4wzjduNb5rQjZxN1lm0mByzRRjyjJNM91tetkMNrM3SzGrMRsyh80dzAXmu82HLdAWThZCiwaLG0wS05OZw2xljlrSLYMtCy27LJ9ZGVjFW22z6rf6aG1vnW7daH3HhmITaFNo02Pzq62ZLde2xvbaXPJc37mr53bPfW5nbse322N3055qH2K/wb7X/oODo4PIoc1h0tHAMdGx1vEGi8YKY21mnXdCO3k5rXY65vTW2cFZ7HzY+RcXpkuaS4vLo3nG8/jzGueNueq5clzrXaVuDLdEt71uUnddd457g/sDD30PnkeTx4SnqWeq50HPZ17WXiKvDq/XbGf2SvYpb8Tbz7vEe9CH4hPlU+1z31fPN9m31XfKz95vhd8pf7R/kP82/xsBWgHcgOaAqUDHwJWBfUGkoAVB1UEPgs2CRcE9IXBIYMj2kLvzDecL53eFgtCA0O2h98KMw5aFfR+OCQ8Lrwl/GGETURDRv4C6YMmClgWvIr0iyyLvRJlESaJ6oxWjE6Kbo1/HeMeUx0hjrWJXxl6K04gTxHXHY+Oj45vipxf6LNy5cDzBPqE44foi40V5iy4s1licvvj4EsUlnCVHEtGJMYktie85oZwGzvTSgKW1S6e4bO4u7hOeB28Hb5Lvyi/nTyS5JpUnPUp2Td6ePJninlKR8lTAFlQLnqf6p9alvk4LTduf9ik9Jr09A5eRmHFUSBGmCfsytTPzMoezzLOKs6TLnJftXDYlChI1ZUPZi7K7xTTZz9SAxESyXjKa45ZTk/MmNzr3SJ5ynjBvYLnZ8k3LJ/J9879egVrBXdFboFuwtmB0pefK+lXQqqWrelfrry5aPb7Gb82BtYS1aWt/KLQuLC98uS5mXU+RVtGaorH1futbixWKRcU3NrhsqNuI2ijYOLhp7qaqTR9LeCUXS61LK0rfb+ZuvviVzVeVX33akrRlsMyhbM9WzFbh1uvb3LcdKFcuzy8f2x6yvXMHY0fJjpc7l+y8UGFXUbeLsEuyS1oZXNldZVC1tep9dUr1SI1XTXutZu2m2te7ebuv7PHY01anVVda926vYO/Ner/6zgajhop9mH05+x42Rjf2f836urlJo6m06cN+4X7pgYgDfc2Ozc0tmi1lrXCrpHXyYMLBy994f9Pdxmyrb6e3lx4ChySHHn+b+O31w0GHe4+wjrR9Z/hdbQe1o6QT6lzeOdWV0iXtjusePhp4tLfHpafje8vv9x/TPVZzXOV42QnCiaITn07mn5w+lXXq6enk02O9S3rvnIk9c60vvG/wbNDZ8+d8z53p9+w/ed71/LELzheOXmRd7LrkcKlzwH6g4wf7HzoGHQY7hxyHui87Xe4Znjd84or7ldNXva+euxZw7dLI/JHh61HXb95IuCG9ybv56Fb6ree3c27P3FlzF3235J7SvYr7mvcbfjT9sV3qID0+6j068GDBgztj3LEnP2X/9H686CH5YcWEzkTzI9tHxyZ9Jy8/Xvh4/EnWk5mnxT8r/1z7zOTZd794/DIwFTs1/lz0/NOvm1+ov9j/0u5l73TY9P1XGa9mXpe8UX9z4C3rbf+7mHcTM7nvse8rP5h+6PkY9PHup4xPn34D94Tz+49wZioAAAAJcEhZcwAALiMAAC4jAXilP3YAAA4OSURBVHic7V0NdBTVFX7vzWyymx8gbhKgQqVQj/hD/avgqQrUqsef0tojLdqjLYLCSXaJASFY63FP1JbDj5hsEgKtthZ/qVal1Vp/qhX/jtWqRaCoFauCoCQgkJDNJvte790ZYIElc3f3kZ3k7HfOZGZ37955O/O9++59786NqZRiObgLG4TIG8lYHRzizZEcNua84Z084uf7PhMEGbsZyd4/6LXRs46kx8n2eYfI4eaTcrOp/crmkDFGMTYRdhWpfo+n+ZmTDOW7yWRT+V7id3B7GzpojpwuBFiOy9O5sf0JXuBojpwugxCCdzD2g2y3I9vIy5HTfWhn7NuwOzbb7cg2wHKKHDldBghYLs92G9wAI2c5XYkfZrsBboDIkdNd6BTim7A7OdvtcAPM3LDuLuSi9APgOcvpLvDckL4fuWHdRWgXohxuxney3Q63QOSGdfcAbsQkFr8nOdjIWU4XITeFlICc5XQJvhCicBBj30vjq4mJGkcb6ZwL47v8NM+Xs5xuwGAp22FXkO126AT40KcAue6Bw7HpfD8XreegHZjuN4qxm4FYv2DxJfL0wPvKsL4sHB6vDOMc8EO+rhgbgO9xpWKK8w6mVBu8/HztunXh5cuXd6V7jjvvvLPQ6/UOF1IOlUIMZJYlwyHJIzBeUWp/sCI5QEoP49zAz2Ez4R2hlMJhDOVw+IvBezF4D63ibvhgd4yxzfDepy0tLdtCoVBvDce9hg4hzhplWcsxGtS533I2NjZeYBjGs9xOD9w/Sc25/Yb1zpgxYx6C3edUvbW1taKspORSZhiTgejnFXi9IxgSS4jkITM/MD0e/1wcLsX54VPoie8Z9r68tLStuanpX0DcJ6Ld3Suqq6s7qO12IzYL4Stj7Da4IrPZgZ+ZCVbCjdzhenLCL/01c85bXR8IBMjEbGhoOAUIch8cnhZ/IwmpjjKKYJsAxJ2Q7/FcBscX9nYDdCEixPhSxu6Gw+M1qNsCo8vMAimfwnVcV5MTh3NuGGc5ySkpf0fVCZb4VFOIl+BwYEaN04cLFi1aNLCmpmZXthuSCnYIMQD8noXQrWey9JLeE4GPmNwTYWzuICn3XwdXk5MLUU0Q6+qIRu+n6Fu8eHFxUUHBE8w9xIyjoKAg7cAhG9grxCWFjC2Hw69rUPcJbNd7pXzOe8gHriUnWLhhBueTCKJ/ufHGG7+k6ARihmA3IqOG6UfXunXrvsp2IyjYI4QfelEduFpXa1CH1nIFRIs1fin3JBNwLTnBub6eEdqnYrHfU/TV19cPzTPNSuLpYYRh78Dl2wT7VvBJ90LwEoVjnCHoEnhhregdN+hDHCN73NCXHMasDvANRgsONmYyy9BbgEh8MhCzEQ4HZ6oLSLkJ/IDrwFq+eKi1TIQryQmRtAkBy3UE0c+379z5N4pOIGYAdj4nObhwf97T1jZ1/vz5Oyl6j4RlTU2vwA04x/F8Sq3J5DxHGzCED4Ue1gS98Eca1OH0WSM4lTfbCw89wpXkLPf7L4Hd1wiiK0OhULeTEJA9D8h+vZMcEHOPDmIigJilJEEpV2d6rqOFTiGmAjGXwmFJprrg2n4Iu+lgLV+mml5XkhMwnSADA22UNKSXHXMMTteUO8lxpR7RQUzwl0+Hsf4ER0FwG1569dUXKquqMj2lVgApR6A/CB3sIg3qYrDd1cLYrcOkTGk+13XkbF6yZAjz+S5zkoOL90rl7NkfUHRC1P8z0smBnCQ5p/NxPpIg9pnkPLhq1aqYjnPqQK0Q4ibG0C9fwC3/OVNshPs0Dazl68PS+LLryAnERCI5tgusHGluc+nSpaW+/PxLCaKt/16//u8UnU6YNWvWYw0NDSNFLHYs3JxByjDyuZS46tkOTPwqFot9dsMNN2zVcS5daBNi9E3WZLqjn0wAulpLtgHfj5Mykq4S95FTqalOKzboG/LW1kcp6vLz869itASER3RFzcBDrHH0sb25Gi8JYY5jbK6HMZxm6yl4puI9iHqm+aR867gMFbmKnMvC4XHcME50kgPq/rEiFGqj6BRKXUNanozFyKtM/QUQiZ96tpWocaYGddixF3zE2K9OkjKqQZ+7yAnEnEoSJC5XNjU1jRacOy5/At6tqKp6k3TufoD/CpE/nLFbIBKfz6ysqkzxLrgr1xZI+e5JGpTtg2vIWVtb6y0vLZ1CEN1YMWvWaxSdVKuplPoNRV9/QIcQZw+3fEsdz8d3gv9yxwbGFp4hpfaFBNeQs9zvx8diHefTFDEQwoJYTQ0NPyWItoOP9ABFZ1+G/SjIHYIxnLfS8SDdWxD1TCuU8r0zNChLBteQE0CZ7unmkch9FGXhcHg8o62jPxwMBndTdPZVdApx/kDGcHQYpUFdBKxl7RsQjU+Q0nEBJBO4gpz2urfjhC9clL9Wzp27jaJTEJMTVCz2W4pcX8RXQgyE8HsJODbTeeZpbYjXYeyeViTlxgkalDnBFeT0GAYOv85tIQZCdXV1vnyP58eOgkqtrayqeoOis68BfMtJPsaamZ5yih1gGG59krG7JkvZa4sGriAn5/wagti27Tt2PEXR5/F4rmCEnE3J+d0UfX0JbUKUQfhdByMHxd+m4OUoWN5iKT+crEkhFVknZ3N9/WnMNE91koNA6D5KkgcCbgwloynS1dXVrwKhiBBXAjHDcFimQR0GijcvYqwxJGVWHsbLOjmBmKR1b8U5aUhvaGg43hRiPEH08erq6h0UnW4HDOHHQods5lZJm4wBQ/iLmG/pk3JTSIfCNJFVck6ZMsWYMH78lQRP/bVAILCRohOIOY0RnH8wBX+g6HMz7Prx04GYi+HlIA0qMSO9poCxFfYSbFaRVXJOOPfcicCioU5ySkpSahwmKZeVlv6cQPbNa9aseR4IT1HrSnQKMXIvYzjTcL4OfcDEZ2A3wyvlp255oD6r5ORCXEUQa2+PRFZR9GHeJonsSj3kplS1VIBpbTWMVYG1vAN+a6EGlfi041ywlve4wVomImvktJcrr3CSg6u1et68eUkfgDoUEPVfS5EDy/AQRc5tgEj8RDutTVcdz6fgWswE33KLW6xlIvaTEwMJA24u3OARYFpK4E7jUuJAOC6OC3COGeLPVAQCc3WcuLS0FGcmnP2kWIxEpHA4PNhjGJS8zfeDweA7FJ09Af29xnC4Bq7LRWDByqETifi/AVTKgOCtkFsPvCl4/cuKYDCjif63hfCcxNh8iMRvYelXbUvETmhvNQzhKzXoOmqIk7O+vn5Qnmm+Dof++LuJyRIHjnEyFzNYtJDTfrrSCa1rN2x4hqIPAiFcEaJk2DxO0eeEpoYGzOhZsO/1YWVyDgDT0dIm514hTj+ZMZypOC1dHYfgCfBnKgukdFWyczLEyekRApMu/I7SSpGI4gSw0mcCmc4jnO8BagIwdUhXsdjTFLmegHWWwCUhdVKV5jX7RAjvEMZChmUMdLhfLWAtZ4G1fFiDrl6B9aOFuJgkzfn7mZ7QttIYfTtP9xBXcOyJfEoKmIxKmXHeZllJCRZ6pXTmLWvXr38yVf0RIc4ZYvmWo9NoXjI82s1YoFBKUvEJt8C0U8smEuWrmpuaBigpNwFxtkJ0twu2NtM0MfO5MxqNHhTtwfsGWA4f7DH9v4hLOQ6IiZZghNOJQNGrgUDgPdqvMKklq3mex1PX3Nj4XLdSG6G9Xxa0te2FO4btN/1+vyna2jyyqMhndHd7uw3DiwUTcBOW730cdNBvccOgzDLgb1iSyqMf24UoKrYeLsOHzHSktX0BgU4AAp4/6XBUexsmDLH4COsQojzKLuBCxEtZGIaBf/Z/6Mt3uARJygYeCXBjbycLM/Zdohx60DPg7wwTjkwv9BnYDnpmuLjYKtPh8Rw8lqZaiU6pTdJKvCChU4gLB1hpbSNSO9ER8SD0uKpiKVs16et14PV3338MU2p1IBhMxVdzXJvPAuYFg8FOJ6HdQpTkWWlt6DPrSGvbCp2iAqzl6r5oLRNhcqW8WahP2RM+7ohGKYkbidDx1KA2gNV/sDIYfMxJrkOIy4FAyxhh4YCIe6E3zBkgZcaFIdwAE3rZO0b8emrptZniA2jPxXPmzGlJ8XtYb1NHdQoduD/a1TWjJ4F2IQbDkBUGJ+cnms75mV109em+bi0TYcLQswGCHEw+wU1HyeRUgR1jHQRZ90ZjseZ0SlB3dnVNy/d4MP2tNxK0kwEXWF6IKbUQrufzPQlCJH41ELOOUaJ9ZyQtutpfEPf5KwKB25ctXbqS5eXhlNJoGOYxRvDDkF/IrPJ+RfaGxziEYgdNxdJixIoXrwUu51bQiQVDMWDAaPyfqZTMTgYg9BbYTQyHwyd4ILAA/SfCTRvFkQBKHWP/hn3tNuzfnWo0jLmkkfimFD5z9DHo/Q8cv8kikWcrHB4fAVIOZ1b9oUtS/oHJ8T9mFV193lU+jUbsD0gr58xBwqygfAlT3caOHes1TdPT3d2d5/V6Td7Z6ek2TSWEwLIrUnR0yE7TjO7atWtvKBRKuyRJKqiqqsJ5WNJcLE6ks+QExfdM6J0i5vcLo7UVJwcj1ETnw5RZaW0zgZQLmf2fQDIEWsvmPYzNL5OSVFiiryKtlQc7o8exvqKbYf+rlSPlO2ipWLFHiOM7rKVLLe4GkPIju+jqP/qrtUxE9jPh+yEeFcL4PmOz8xi7jREK1hKAnSgMftEtlKKr/QU5cmoG/lu9SdbS4zhNKj9QVtHVVzKud93HkCOnJuj6t3oJiBdd3Z5G0dX+ghw5NcAOevBR3BJlWU28ria398wKsgQ78NpUh8skyu6GcbzGJ+Ub6RRd7S/4P+IKbZ5IXRm8AAAAAElFTkSuQmCC";

  const formatCPF = (cpf) => {
    // Remove quaisquer caracteres não numéricos
    const onlyNumbers = cpf.replace(/\D/g, "");

    // Formata a string como ###.###.###-##
    return onlyNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mês começa em 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };


  const generatePDF = (data) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "cm",
      format: [13, 7], // Tamanho do ticket em centímetros
    });

    // Largura da página
    const pageWidth = doc.internal.pageSize.getWidth();

    // Adicionar o logo no PDF
    doc.addImage(LOGO_BASE64, 'PNG', 0.5, 0.5, 2.8, 1);

    // Configurar fonte e tamanho padrão
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.8);

    // Cabeçalho
    doc.text("Rod. P. Manoel da Nobrega", 3.6, 0.8);
    doc.text("N°83103 - São Vicente/SP", 3.7, 1.2);

    // Título
    doc.setFontSize(12);
    // Título centralizado
    const title = `Ticket de Pesagem Nº ${data.ID_CARREGAMENTO}`;
    doc.text(title, (pageWidth - doc.getTextWidth(title)) / 2, 2.5);

    // Informações principais
    doc.setFontSize(9);
    doc.text(`${data.nomeMotorista}`, 0.5, 3.5);
    // Formatar CPF
    const formattedCPF = formatCPF(data.cpfMotorista);

    // Exibir CPF formatado no PDF
    doc.text(`CPF: ${formattedCPF}`, 0.5, 4);

    // Tabela de duas colunas
    doc.setFontSize(10);

    // Ajuste da Tabela
    const pagePadding = 0.4; // Margem lateral para centralizar
    const totalWidth = 6.2; // Largura total disponível para a tabela (menor que antes)
    const cellWidth = totalWidth / 2; // Cada célula terá largura menor
    const startX = pagePadding; // Início da tabela, respeitando a margem
    const startY = 4.3; // Posição inicial da tabela (y)
    const cellHeight = 0.5; // Altura de cada célula

    // Configurar espessura da linha para bordas finas
    doc.setLineWidth(0.05); // Define a espessura da borda

    // Primeira linha - Cabeçalho
    doc.setFontSize(8);
    doc.rect(startX, startY, cellWidth, cellHeight); // Borda da primeira célula
    doc.text("Nº Container", startX + 0.2, startY + 0.4); // Texto na primeira célula

    doc.rect(startX + cellWidth, startY, cellWidth, cellHeight); // Borda da segunda célula
    doc.text("Tipo de Contêiner", startX + cellWidth + 0.2, startY + 0.4); // Texto na segunda célula

    // Segunda linha - Dados
    doc.rect(startX, startY + cellHeight, cellWidth, cellHeight); // Borda da primeira célula na segunda linha
    doc.text(data.numeroContainer, startX + 0.2, startY + cellHeight + 0.4); // Dados na primeira célula

    doc.rect(startX + cellWidth, startY + cellHeight, cellWidth, cellHeight); // Borda da segunda célula na segunda linha
    doc.text(data.tipoContainer, startX + cellWidth + 0.2, startY + cellHeight + 0.4); // Dados na segunda célula

    doc.text(`Transp: ${data.transp}`, 0.5, 5.8);
    doc.setFontSize(8.5);
    // Configurar fonte para negrito
    doc.setFont("helvetica", "bold");
    const dataPDF = new Date(); // Pega a data atual
    dataPDF.setHours(dataPDF.getHours() - 3); // Subtrai 3 horas

    const dataFormatadaPDF = dataPDF.toISOString().slice(0, 19).replace("T", " "); // Formata a data ajustada
    const centralText = `${data.tipoFluxo} - ${dataFormatadaPDF}`;
    // Calcular largura do texto
    const textWidth = doc.getTextWidth(centralText);

    // Centralizar horizontalmente
    doc.text(centralText, (pageWidth - textWidth) / 2, 6.4);
    doc.setFont("helvetica", "normal");

    // Assinaturas
    doc.text("______________________________", 1, 8);
    // Centralizar o nome do motorista
    const motoristaName = data.nomeMotorista;
    doc.setFontSize(8.1);
    doc.text(motoristaName, (pageWidth - doc.getTextWidth(motoristaName)) / 2, 8.6);

    doc.text("________________________________", 1, 10.1);
    // Centralizar o nome da empresa
    const companyName = "JC7 Terminais Portuários e Transportes Ltda";
    doc.text(companyName, (pageWidth - doc.getTextWidth(companyName)) / 2, 10.7);

    // Salvar o PDF
    doc.save("ticket.pdf");
  };

  // Função para buscar motorista
  const getMotorista = () => {
    const cpfSemMascara = cpfMotorista.replace(/\D/g, "");

    if (!cpfSemMascara || cpfSemMascara.length < 11) {
      alert("CPF inválido ou não informado corretamente.");
      setNomeMotorista("");
      setCodMotorista(null);
      return;
    }

    Axios.get(`https://portal.jc7transportes.com.br/api/motorista/busca/${cpfSemMascara}`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setNomeMotorista(res.data[0].NOME_MOTORISTA);
          setCodMotorista(res.data[0].COD_MOTORISTA);
        } else {
          setNomeMotorista("");
          setCodMotorista(null);
          setShowModal(true); // Exibe o modal caso o motorista não seja encontrado
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar motorista:", error);
        alert("Erro ao buscar motorista.");
      });
  };



  // Busca transportadoras da API
  const getTransp = () => {
    Axios.get(`https://portal.jc7transportes.com.br/api/transportadora`)
      .then((res) => {
        setTransportadoras(res.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar transportadoras:", error);
      });
  };

  useEffect(() => {
    getTransp(); // Chama a função para buscar transportadoras ao montar o componente
  }, []);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (photos.length >= 4) {
      alert("Você só pode adicionar até 4 fotos.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotos((prevPhotos) => [...prevPhotos, { file, preview: reader.result }]);
    };
    reader.readAsDataURL(file);

    e.target.value = "";
  };

  const handleRemovePhoto = (index) => {
    setPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedTransportadora) {
      alert("Por favor, selecione uma transportadora.");
      return;
    }

    if (!tipoContainer) {
      alert("Por favor, selecione o tipo de Contêiner.");
      return;
    }

    if (!codMotorista) {
      alert("Por favor, informe o CPF e busque o motorista antes de enviar.");
      return;
    }

    const data = new Date();
    const dataFormatada = data.toISOString().slice(0, 19).replace("T", " ");

    const payload = {
      tipoFluxo: tipofluxo,
      numeroContainer,
      codMotorista,
      codTransp: selectedTransportadora,
      tipoContainer: tipoContainer,
      dataCadastro: dataFormatada,
    };

    try {
      const response = await Axios.post("https://portal.jc7transportes.com.br/api/carregamento", payload);

      if (response.status === 201) {
        const { ID_CARREGAMENTO } = response.data; // Captura o ID gerado pela API
        alert("Checklist enviado com sucesso!");

        // Gerar PDF com os dados do ticket
        generatePDF({
          nomeMotorista,
          cpfMotorista,
          numeroContainer,
          tipoContainer: tipoContainer,
          transp: transportadoras.find((t) => t.COD_TRANSP === selectedTransportadora)?.NOME_TRANSP || "",
          dataCadastro: dataFormatada,
          tipoFluxo: tipofluxo,
          ID_CARREGAMENTO, // Passar o ID_CARREGAMENTO para o PDF
        });


      // Atualizar a página
      window.location.reload(); // Recarregar a página para refletir os dados atualizados

      } else {
        throw new Error("Erro ao enviar os dados.");
      }
    } catch (error) {
      console.error("Erro:", error);
      alert("Ocorreu um erro ao enviar os dados.");
    }
  };


  const [tipoContainer, setTipoContainer] = useState("");

  const handleContainerChange = (e) => {
    setTipoContainer(e.target.value);
    console.log(`Selecionado Contêiner de ${e.target.value} pés`);
  };

  // Função para aplicar a máscara
  const aplicarMascaraContainer = (valor) => {
    // Remove todos os caracteres que não são letras ou números
    valor = valor.replace(/[^A-Za-z0-9]/g, "");

    // Aplica a máscara no formato ABCD-000.000-0
    if (valor.length <= 4) {
      return valor.toUpperCase();
    }
    if (valor.length <= 7) {
      return valor.slice(0, 4) + '-' + valor.slice(4, 7);
    }
    if (valor.length <= 10) {
      return valor.slice(0, 4) + '-' + valor.slice(4, 7) + '.' + valor.slice(7, 10);
    }
    return valor.slice(0, 4) + '-' + valor.slice(4, 7) + '.' + valor.slice(7, 10) + '-' + valor.slice(10, 11);
  };

  // Função para adicionar um novo motorista
  const addMotorista = () => {
    if (!nomeMotoristaModal || nomeMotoristaModal.trim() === "") {
      alert("Por favor, insira o nome do motorista.");
      return;
    }

    const cpfSemMascara = cpfMotorista.replace(/\D/g, "");

    const payload = {
      nome: nomeMotoristaModal,
      cnh: 0,
      cpf: cpfSemMascara,
      usuario: "USUARIO_DO_MOTORISTA", // Adapte conforme necessário
    };

    Axios.post("https://portal.jc7transportes.com.br/api/motorista/criar", payload)
      .then((response) => {
        if (response.data === "sucesso") {
          alert("Motorista cadastrado com sucesso!");
          setShowModal(false); // Fecha o modal após sucesso
          getMotorista(); // Atualiza a busca após a inserção
        } else {
          alert("Erro ao cadastrar motorista.");
        }
      })
      .catch((error) => {
        console.error("Erro ao adicionar motorista:", error);
        alert("Erro ao adicionar motorista.");
      });
  };



  return (
    <>
      <Navbar />
      <Header />
      <Background />
      <Container>
        <br />
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.active}>
              Check List
            </div>
            <div className={style.navbar} onClick={() => navigate("/containers/historicocontainers")}>
              Histórico
            </div>
            <div className={style.navbar} onClick={() => navigate("/veiculos")}>
              Cadastrar Motorista
            </div>
          </div>
          <div className={style.checklist}>
            <h2>Checklist de Contêiner Vazio</h2>

            <div className={style.radioGroup}>
              <label className={style.input}>
                <input
                  type="radio"
                  onChange={(e) => setTipoFluxo(e.target.value)}
                  value="ENTRADA"
                  name="tipofluxo"
                  checked={tipofluxo === "ENTRADA"}
                />
                ENTRADA
              </label>
              <label className={style.input}>
                <input
                  type="radio"
                  onChange={(e) => setTipoFluxo(e.target.value)}
                  value="SAÍDA"
                  name="tipofluxo"
                  checked={tipofluxo === "SAÍDA"}
                />
                SAÍDA
              </label>
            </div>

            <form onSubmit={handleSubmit}>
              <div>
                <label>
                  Número do Contêiner:
                  <input
                    type="text"
                    placeholder="Ex: ABCD-000.000-0"
                    value={numeroContainer}
                    onChange={(e) => setNumeroContainer(aplicarMascaraContainer(e.target.value))}
                    required
                  />
                </label>
              </div>
              <div>
                <label>
                  CPF do Motorista:
                  <input
                    type="number" // Alterado para text
                    placeholder="Digite o CPF (apenas números)"
                    value={cpfMotorista}
                    onChange={(e) => setCpfMotorista(e.target.value)}
                    onBlur={getMotorista} // Mantido, mas pode-se optar por um botão de busca
                    required
                  />
                </label>

              </div>
              {nomeMotorista && (
                <div>
                  <p>Motorista: <strong>{nomeMotorista}</strong></p>
                </div>
              )}

              {/* Modal de Cadastro de Motorista */}
              {showModal && (
                <div className={modalStyle.overlay}> {/* Camada de fundo escuro */}
                  <div className={modalStyle.modal}>
                    <div className={modalStyle.content}>
                      <h3>Motorista não encontrado</h3>
                      <p>Por favor, insira o nome completo do motorista para cadastrá-lo:</p>
                      <input
                        type="text"
                        value={nomeMotoristaModal}
                        onChange={(e) => setNomeMotoristaModal(e.target.value)}
                        placeholder="Nome Completo"
                        required
                      />
                      <button type="button" onClick={addMotorista}>Cadastrar Motorista</button>
                      <button type="button" onClick={() => setShowModal(false)}>Fechar</button>
                    </div>
                  </div>
                </div>
              )}

              <div>
                <label>
                  Transportadora:
                  <select
                    onChange={(e) => setSelectedTransportadora(parseInt(e.target.value, 10))}
                    required
                  >
                    <option disabled selected>Escolha uma opção</option>
                    {transportadoras.map((val) => (
                      <option value={val.COD_TRANSP} key={val.COD_TRANSP}>
                        {val.NOME_TRANSP}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className={style.containerType}>
                <label>Tipo de Contêiner</label>
                <div className={style.containerOptions}>
                  <label className={style.option}>
                    <input
                      type="radio"
                      name="tipoContainer"
                      value="40"
                      onChange={handleContainerChange}
                    />
                    <div className={style.iconWrapper}>
                      <img
                        src={QuarentaPes}
                        alt="Contêiner de 40 pés"
                        className={style.icon}
                      />
                      <p>40 Pés</p>
                    </div>
                  </label>
                  <label className={style.option}>
                    <input
                      type="radio"
                      name="tipoContainer"
                      value="20"
                      onChange={handleContainerChange}
                    />
                    <div className={style.iconWrapper}>
                      <img
                        src={VintePes}
                        alt="Contêiner de 20 pés"
                        className={style.icon}
                      />
                      <p>20 Pés</p>
                    </div>
                  </label>
                </div>

              </div>
              <div>
                <label>
                  O Contêiner está com avarias?
                  <select onChange={(e) => setHasDamage(e.target.value === "Sim")} required>
                    <option value="Não">Não</option>
                    <option value="Sim">Sim</option>
                  </select>
                </label>
              </div>

              {hasDamage && (
                <>
                  <div>
                    <label>
                      Observação:
                      <textarea
                        placeholder="Descreva as avarias"
                        value={observacao}
                        onChange={(e) => setObservacao(e.target.value)}
                        required
                      />
                    </label>
                  </div>
                  <div>
                    <label>
                      Tirar Foto ou Adicionar:
                      <input
                        type="file"
                        accept="image/*"
                        capture="camera"
                        onChange={handlePhotoChange}
                      />
                    </label>
                  </div>
                  {photos.length > 0 && (
                    <div className={style.photoList}>
                      <p>Fotos adicionadas:</p>
                      <ul>
                        {photos.map((photo, index) => (
                          <li key={index}>
                            <img
                              src={photo.preview}
                              alt={`Foto ${index + 1}`}
                              className={style.thumbnail}
                            />
                            <button
                              type="button"
                              onClick={() => handleRemovePhoto(index)}
                              className={style.removeButton}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </>
              )}
              <div>
                <button type="submit">Enviar</button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Containers;
